import React from 'react';
// import { AppWrap } from './wrapper';
import { About, Skills, Footer, Work, Header } from './container';
import { Navbar } from './components';
import './App.scss' ;
const App = () => {
  return (
    <div className='app'>
      {/* <AppWrap /> */}
      <Navbar />
      <Header />
      <About />
      <Work />
      <Skills />
      <Footer />
    </div>
  );
}

export default App
